import React, { Suspense } from 'react';
import { pick, prop } from 'ramda';
import * as urlUtil from 'js/utils/url.util';
import { Button } from 'js/components/common/Button';
import { LogoutButton } from 'js/components/main/LogoutButton';
import { SessionTicker } from 'js/components/main/SessionTicker';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { BackboneReplacer } from 'js/backbone/components/BackboneReplacer';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { Logo } from '../Logo';
import { Inbox } from '../Inbox';
import * as hooks from '../../hooks';
import { Language } from '../Language';
import { MyAccount } from '../MyAccount';
import { MyBalance } from '../MyBalance';
import { AdditionalUserInfo } from '../AdditionalUserInfo';

import style from './DesktopHeader.scss';

export const DesktopHeader: React.FC = () => {
    const translate = useComponentTranslations();
    const onLoginButtonClick = hooks.useOnLoginButtonClick();
    const { showSessionTicker, registrationURL } = useAppSelector(pick([
        'showSessionTicker', 'registrationURL'
    ]));
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const hideChatByUrl = urlUtil.getLocationParam('hideChat') === '1';

    const Chat = hideChatByUrl ? null : (
        <div className={style.chat}>
            <BackboneReplacer dynamicName="CHAT_BUTTON" viewName="chatbutton" />
        </div>
    );

    return (
        <div className={style.header}>
            <div className={style.info}>
                <Logo />
                {isLoggedIn && showSessionTicker && (
                    <Suspense fallback="">
                        <SessionTicker className={style.ticker} />
                    </Suspense>
                )}
            </div>
            <div className={style.controls}>
                {isLoggedIn
                    ? (
                        <>
                            <AdditionalUserInfo />
                            <MyAccount />
                            {Chat}
                            <Inbox />
                            <MyBalance />
                            <div className={style.deposit}>
                                <BackboneReplacer dynamicName="HEADER_DEPOSIT_BUTTON" viewName="headerdepositbutton" />
                            </div>
                            <Language />
                            <Suspense fallback="">
                                <LogoutButton className={style.logout} />
                            </Suspense>
                        </>
                    )
                    : (
                        <>
                            {Chat}
                            <Language />
                            <Button
                                size="small"
                                color="success"
                                view="secondary"
                                className={style.login}
                                onClick={onLoginButtonClick}
                            >
                                {translate('login.button.loginHeader')}
                            </Button>
                            {registrationURL && (
                                <Button
                                    size="small"
                                    color="revert"
                                    view="secondary"
                                    href={registrationURL}
                                    className={style.register}
                                >
                                    {translate('login.button.join_now')}
                                </Button>
                            )}
                        </>
                    )
                }
            </div>
        </div>
    );
};
